import { LockKeyholeOpen, Ticket, UserPlus } from 'lucide-react'
import React from 'react'
import { cn } from '../../lib/utils'

const ReferralStep: React.FC = () => {

  const steps = [
    {
      label: 'Share your referral link',
      icon: UserPlus
    },
    {
      label: 'Ensure your friends complete their AyeFace registration through your referral link',
      icon: LockKeyholeOpen
    },
    {
      label: 'Receive [amount] [reward type] once your friend spent with AyeFace',
      icon: Ticket
    }
  ]
  return (
    <div className="flex flex-col gap-4 mt-8">
      <h3 className="text-center">
        How Referrals Work
      </h3>
      
      <ol className="relative border-s border-[#B7A9A680] ml-2 mt-1">
        {steps.map((step, index) => (
          <li key={index} className={cn("ms-8 flex items-center", index === steps.length - 1 ? 'mb-0' : 'mb-5')}>
            <div className="absolute w-8 h-8 bg-white rounded-full -start-4 border shadow-lg shadow-black/20">
              <step.icon className="w-4 h-4 text-primary absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2" />
            </div>
            <p className="mb-1 text-sm font-normal leading-none">{step.label}</p>
          </li>
        ))}
      </ol>

      <p className='text-sm mt-6'>
        Your friend will receive their reward after completing the registration and linking at least one payment method to their AyeFace account. They can use the rewards at merchant locations with AyeFace Basic/Pro plans.
      </p>
    </div>
  )
}

export default ReferralStep